/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENTS_TAB = "ALL_COMMENTS" | "FEATURED_COMMENTS" | "NONE" | "UNANSWERED_COMMENTS" | "%future added value";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type StreamQueryLocal = {
    readonly storyID: string | null;
    readonly storyURL: string | null;
    readonly commentsOrderBy: COMMENT_SORT;
    readonly commentsTab: COMMENTS_TAB;
    readonly " $refType": "StreamQueryLocal";
};
export type StreamQueryLocal$data = StreamQueryLocal;
export type StreamQueryLocal$key = {
    readonly " $data"?: StreamQueryLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"StreamQueryLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamQueryLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyID",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storyURL",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsOrderBy",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsTab",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '2a6d20f0920aa24bb6a13a568db1a4a4';
export default node;
